import ButtonML from '@/components/button_ml/ButtonML';
import styles from './action.less?modules';
import { useTrigger } from '@/utils/comHook.js';
import ModalML from '@/components/modal_ml/ModalML';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { useDispatch, useSelector } from 'dva';
import EditModal from '@/containers/edit_modal/EditModal';
import { message } from 'antd';
import { fieldPackageStatus2 } from '@/constants.js';
import { toOption } from '@/utils/comUtil.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
// import Dropdown from '../dropdown_ml/Dropdown';

const formList = [
  {
    name: 'name',
    type: 'input',
    label: '字段包名',
    required: true,
  },
  {
    name: 'description',
    type: 'input',
    label: '描述',
    required: true,
  },
  {
    name: 'fieldPackageStatus',
    type: 'select',
    label: '状态',
    required: true,
    option: toOption(fieldPackageStatus2),
  },
];
const Action = (props) => {
  const { fetchData } = props;
  const editTrigger = useTrigger();
  const deleteTrigger = useTrigger();
  const { singleListInfo } = props;
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['cfpm/addFieldPackage'];
  const handleDelete = () => {
    deleteFieldPackage(singleListInfo.id);
  };
  const deleteFieldPackage = (id) => {
    dispatch({
      type: 'cfpm/deleteFieldPackage',
      payload: {
        id,
      },
      callback: (res) => {
        if (res && res.message) {
          message.error(res.message);
        } else {
          message.success('删除成功');
          fetchData();
          deleteTrigger.close();
        }
      },
    });
  };
  const editSingleFieldPackage = (value, id) => {
    dispatch({
      type: 'cfpm/addFieldPackage',
      payload: {
        values: {
          ...value,
        },
        id,
      },
      callback: (res) => {
        if (res && res.code === 0) {
          message.success('编辑成功');
          fetchData();
          editTrigger.close();
        } else {
          message.error(res.message);
        }
      },
    });
  };

  // const menuClick = (a, b) => {
  //   if (a === '1') {
  //     console.log(a);
  //   } else if (a === '2') {
  //     dispatch({
  //       type: 'cfpm/exportFieldPackage',
  //       payload: {
  //         id: b.id,
  //       },
  //       callback: (res) => {
  //         const blob = new Blob([res], {
  //           type: 'application/json; charset=utf-8',
  //         });
  //         const fileName = new Date().getTime() + '.json';
  //         if (window.navigator.msSaveOrOpenBlob) {
  //           // IE10+
  //           navigator.msSaveBlob(blob, fileName);
  //           message.success('导出成功');
  //         } else if ('download' in document.createElement('a')) {
  //           // 非IE
  //           const link = document.createElement('a');
  //           link.href = window.URL.createObjectURL(blob);
  //           link.download = fileName;
  //           document.body.appendChild(link);
  //           link.style.display = 'none';
  //           link.click();
  //           window.URL.revokeObjectURL(link.href);
  //           link.remove();
  //           message.success('导出成功');
  //         } else {
  //           message.error('当前浏览器不支持!');
  //         }
  //       },
  //     });
  //   }
  //   // props.menuClick(a, b);
  // };

  // 导入文件
  // const uploadAction = (e) => {
  //   const formData = new FormData();
  //   formData.append('uploadFile', e);
  //   dispatch({
  //     type: 'cfpm/uploadFile',
  //     payload: {
  //       values: formData,
  //     },
  //     callback: (res) => {
  //       if (res && res.code === 2) {
  //         message.error('导入文件内容不符合规格');
  //       } else {
  //         message.success('导入成功');
  //       }
  //     },
  //   });
  // };

  return (
    <div className={styles.handle_btn}>
      <ButtonML size="large" value="编辑" onClick={editTrigger.open} />
      <ModalConfirmML
        title="是否确认删除?"
        handleOk={handleDelete}
        handleCancel={deleteTrigger.close}
        visible={deleteTrigger.visible}
        disabled={!singleListInfo.deletable}
        value="删除"
        icon={<ExclamationCircleOutlined />}
      />
      {/* <ButtonML size="large" value="其他操作" fontsize="14px" /> */}
      {/* <Dropdown
        size="large"
        title="其他操作"
        fontsize="14px"
        item={singleListInfo}
        menuClick={menuClick}
        uploadAction={uploadAction}
      /> */}
      <ModalML
        title="编辑"
        handleOk={editTrigger.open}
        handleCancel={editTrigger.close}
        visible={editTrigger.visible}
      >
        <EditModal
          singleListInfo={singleListInfo}
          handleCancel={editTrigger.close}
          edit={editSingleFieldPackage}
          formList={formList}
          loading={loading}
        />
      </ModalML>
    </div>
  );
};
export default Action;
